export const languageNames = (lang: string): string => {
  try {
    if (lang === 'cld') return 'Chaldean'
    if (lang === 'nan') return 'Taiwanese' // Taiwanese Hokkien
    if (lang === 'war') return 'Visayan'
    const name = new Intl.DisplayNames(['en'], { type: 'language' }).of(lang)
    return name || ''
  } catch {
    return lang
  }
}

const purgeName = (str: string): string => {
  let result = str.endsWith('.') ? str.slice(0, -1) : str
  result = result.replaceAll('.', '-').replaceAll(' ', '-').toLowerCase()
  return result
}

export const providerSlug = (firstName: string, lastName: string): string => {
  const first = `${purgeName(firstName)}-`
  const last = `${purgeName(lastName)}`
  return `${first}${last}`
}

export const nameInitials = (name: string): string => {
  const split = name.split(' ')
  if (split.length === 1) return split[0].charAt(0)
  return `${split[0].charAt(0)}${split[1].charAt(0)}`
}

export const isNumber = (value: string): boolean => /^-?\d+$/.test(value)

function isDSTActive() {
  // Create a date object that is now
  const today = new Date()
  // Get the year as a number
  const thisYear = today.getFullYear()

  const todayTimezoneOffSet = today.getTimezoneOffset()

  const julyDate = new Date(thisYear, 6, 1);
  const julyTimezoneOffSet = julyDate.getTimezoneOffset();

  const isActive = julyTimezoneOffSet === todayTimezoneOffSet;

  return isActive;
}

export const toPT = (dt: Date): Date => {
  const dtDateOnly = new Date(dt.valueOf() + (dt.getTimezoneOffset() * 60 * 1000) + (isDSTActive() ? -7 : -8) * 60 * 60 * 1000)
  return dtDateOnly
}
